import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import { useSessionLanguage } from '@context/SessionSettingsContext'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'
import { getDomainName } from '@utils/cookie.utils'

import { PlatformInfoDto } from '@model/PlatformInfoDto'
import { OperatingSystemEnum, PlatformTypeEnum } from '@model/PlatformTypeEnum'

export type TradingViewPlatformLinks = {
  iosLink?: string
  androidLink?: string
}

export const useTradingViewPlatformLinks = (): TradingViewPlatformLinks => {
  const locale = useSessionLanguage()
  const apiClient = useApiClient(ClientApiClient)

  const { data: platformInfo = [] } = useQuery<PlatformInfoDto[]>({
    queryKey: queryKeys.platforms.info(locale),
    queryFn: () =>
      apiClient.getPlatformInfo({
        domain: getDomainName(true),
        languageId: locale,
      }),
  })

  return useMemo(() => {
    const tradingViewPlatform = platformInfo.find(
      (p) => p.platfromType.id === PlatformTypeEnum.TradingView
    )

    const iosLink = tradingViewPlatform?.platformLinks.find(
      (link) => link.operatingSystem.id === OperatingSystemEnum.IOS
    )?.productLink

    const androidLink = tradingViewPlatform?.platformLinks.find(
      (link) => link.operatingSystem.id === OperatingSystemEnum.ANDROID
    )?.productLink

    return { iosLink, androidLink }
  }, [platformInfo])
}
